export const VisitorLog = [{
  path: 'visitors-log',
  component: () => import('../../../components/router-view'),
  children: [
    {
      path: '',
      name: 'visitorsLog',
      component: () => import('../../../components/Admin/visitorsLog.vue'),
      meta: {
        access: ['admin']
      }
    },
    {
      path: 'theme/:id',
      name: 'visitorsLogTheme',
      component: () => import('../../../components/Admin/visitorsLogTheme'),
      meta: {
        access: ['admin']
      }
    },
    {
      path: 'user/:id/:themeId',
      name: 'visitorsLogUser',
      component: () => import('../../../components/Admin/visitorsLogUser.vue'),
      meta: {
        access: ['admin']
      }
    }
  ]
}]



// WEBPACK FOOTER //
// ./src/router/admin/module/visitorLog.js